// JsFromRoutes CacheKey d617ad0ce1e2d8b2b581b070ecc2c141
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  updatePreferredPlaybackRate: definePathHelper('post', '/user/update_preferred_playback_rate'),
  updatePlaybackPosition: definePathHelper('post', '/user/update_playback_position'),
}
